export default __webpack_public_path__ + "static/media/clock-white.87652351.svg";